import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from '../hook-utils';
import { QueueRegion, QueueRegionId, QueueStats } from '../model';
import { actions } from '../store';
import { selectMyData, selectQueueRegions, selectRegions } from '../store/reducers/config';
import { selectDirectoryView } from '../store/reducers/localSettings';
import { MenuItem, SubMenu } from './Menu';
import QueueIcon from './QueueIcon';
import { selectFavQueues, selectMyQueues } from '../store/reducers/queues';
import { routerActions } from 'connected-react-router';

interface Props {
  onClick?(r: QueueRegion): void
}

export function QueueRegionDropdownItems({ onClick }: Props) {
  const regions = useSelector(selectQueueRegions)
  const favourites = useSelector(selectFavQueues)
  const mine = useSelector(selectMyQueues)
  const dispatch = useDispatch()

  useEffect(() => {
    if (mine) return
    dispatch(actions.fetchMyQueues.request())

  }, [dispatch, mine])

  useEffect(() => {
    if (favourites) return
    dispatch(actions.fetchFavQueues.request())

  }, [dispatch, favourites])

  function handleClick(region: QueueRegion) {
    dispatch(actions.setQueueView({ region }))
    if (onClick) {
      onClick(region)
    }
  }

  function getQueueMenu(key: string, queues: QueueStats[]) {
    return queues.map(x => {
      return <MenuItem key={'fav-' + x.id} onClick={() => {
        dispatch(routerActions.replace('/queues'))
        dispatch(actions.setQueueView({ region: undefined, queue: { id: x.id, server: x.server } }))
      }}>
        <QueueIcon icon={x.icon} />{x.description}
      </MenuItem>
    })
  }

  return <>
    {regions.map((r, i) => {
      const region = getQueueRegionName(r)
      if (r === QueueRegionId.Favourites && favourites.length > 0) {
        return <MenuItem key={i} onClick={() => handleClick(r)} subMenu={<SubMenu>{getQueueMenu('fav-q-', favourites)}</SubMenu>}>{region}</MenuItem>
      } else if (r === QueueRegionId.Mine && mine.length > 0) {
        return <MenuItem key={i} onClick={() => handleClick(r)} subMenu={<SubMenu>{getQueueMenu('mine-q-', mine)}</SubMenu>}>{region}</MenuItem>
      }

      return <MenuItem key={i} onClick={() => handleClick(r)}>{region}</MenuItem>
    },
    )}
  </>
}

export function DirectoryDropdownItems({ onClick }: { onClick?(): void }) {
  const regions = useSelector(selectRegions)
  const view = useSelector(selectDirectoryView)
  const dispatch = useDispatch()
  const myData = useSelector(selectMyData)

  function handleClick(regionId: string | 'favourite') {
    const v = { regionId, entityType: view.entityType, contactType: view.contactType }
    dispatch(actions.setDirectoryView(v))
    if (onClick) {
      onClick()
    }
  }

  if (!myData || !regions) return <></>

  return <>
    <MenuItem key={'my' + myData.regionId} onClick={() => handleClick(myData.regionId)}>My Region</MenuItem>
    <MenuItem key={'fav' + myData.regionId} onClick={() => handleClick('favourite')}>Favourites</MenuItem>
    {regions.map((r, i) => {
      return <MenuItem key={i} onClick={() => handleClick(r.id)}>{r.name}</MenuItem>
    },
    )}
  </>
}

export function getQueueRegionName(r: QueueRegion) {
  return r === QueueRegionId.Favourites ? 'Favourites'
    : r === QueueRegionId.Mine ? 'My queues'
      : r === QueueRegionId.Squads ? 'Squads'
        : r.name
}
